export const DIAGRAM_EXIT_CONFIRM_MESSAGE = 'вы точно хотите выйтии?';
export const DIAGRAM_DRAFT_STATUS = 'draft';

const DRAFT_KEY_PREFIX = 'arch-editor:diagram-draft';

export const buildDiagramDraftKey = ({ projectId, diagramId, mode }) => (
  `${DRAFT_KEY_PREFIX}:${projectId || 'local'}:${diagramId || 'new'}:${mode || 'diagram'}`
);

export const withDraftStatus = (meta = {}) => ({
  ...meta,
  sync_status: DIAGRAM_DRAFT_STATUS,
});

export const writeDiagramDraft = (key, payload) => {
  if (!key || typeof window === 'undefined' || !window.localStorage) return null;
  const value = {
    ...payload,
    savedAt: new Date().toISOString(),
  };
  window.localStorage.setItem(key, JSON.stringify(value));
  return value;
};

export const readDiagramDraft = (key) => {
  if (!key || typeof window === 'undefined' || !window.localStorage) return null;
  const raw = window.localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearDiagramDraft = (key) => {
  if (!key || typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.removeItem(key);
};
